// Recovered compiled webpack factory 63499. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      IDLE_LINK_STATUS: function () {
        return c;
      },
      PENDING_LINK_STATUS: function () {
        return u;
      },
      mountFormInstance: function () {
        return v;
      },
      mountLinkInstance: function () {
        return y;
      },
      onLinkVisibilityChanged: function () {
        return E;
      },
      onNavigationIntent: function () {
        return R;
      },
      pingVisibleLinks: function () {
        return S;
      },
      setLinkForCurrentNavigation: function () {
        return f;
      },
      unmountLinkForCurrentNavigation: function () {
        return d;
      },
      unmountPrefetchableInstance: function () {
        return b;
      },
    }),
    r(11807));
  let n = r(17297),
    a = r(66048),
    o = r(12115),
    i = r(86871),
    s = r(48302),
    l = null,
    u = { pending: !0 },
    c = { pending: !1 };
  function f(e) {
    (0, o.startTransition)(() => {
      (null == l || l.setOptimisticLinkStatus(c),
        null == e || e.setOptimisticLinkStatus(u),
        (l = e));
    });
  }
  function d(e) {
    l === e && (l = null);
  }
  let p = "function" == typeof WeakMap ? new WeakMap() : new Map(),
    h = new Set(),
    _ =
      "function" == typeof IntersectionObserver
        ? new IntersectionObserver(
            function (e) {
              for (let t of e) {
                let e = t.intersectionRatio > 0;
                E(t.target, e);
              }
            },
            { rootMargin: "200px" },
          )
        : null;
  function m(e, t) {
    (void 0 !== p.get(e) && b(e), p.set(e, t), null !== _ && _.observe(e));
  }
  function g(e) {
    try {
      return (0, n.createPrefetchURL)(e);
    } catch (t) {
      return (
        ("function" == typeof reportError ? reportError : console.error)(
          "Cannot prefetch '" + e + "' because it cannot be converted to a URL.",
        ),
        null
      );
    }
  }
  function y(e, t, r, n, a, o) {
    if (a) {
      let a = g(t);
      if (null !== a) {
        let t = {
          router: r,
          fetchStrategy: n,
          isVisible: !1,
          prefetchTask: null,
          prefetchHref: a.href,
          setOptimisticLinkStatus: o,
        };
        return (m(e, t), t);
      }
    }
    return {
      router: r,
      fetchStrategy: n,
      isVisible: !1,
      prefetchTask: null,
      prefetchHref: null,
      setOptimisticLinkStatus: o,
    };
  }
  function v(e, t, r, n) {
    let a = g(t);
    null !== a &&
      m(e, {
        router: r,
        fetchStrategy: n,
        isVisible: !1,
        prefetchTask: null,
        prefetchHref: a.href,
        setOptimisticLinkStatus: null,
      });
  }
  function b(e) {
    let t = p.get(e);
    if (void 0 !== t) {
      (p.delete(e), h.delete(t));
      let r = t.prefetchTask;
      null !== r && (0, a.cancelPrefetchTask)(r);
    }
    null !== _ && _.unobserve(e);
  }
  function E(e, t) {
    let r = p.get(e);
    void 0 !== r &&
      ((r.isVisible = t), t ? h.add(r) : h.delete(r), P(r, a.PrefetchPriority.Default));
  }
  function R(e, t) {
    let r = p.get(e);
    void 0 !== r && void 0 !== r && P(r, a.PrefetchPriority.Intent);
  }
  function P(e, t) {
    var r;
    let n = e.prefetchTask;
    if (!e.isVisible) {
      null !== n && (0, a.cancelPrefetchTask)(n);
      return;
    }
    ((r = e),
      (async () => {
        let e;
        switch (r.fetchStrategy) {
          case a.FetchStrategy.PPR:
            e = i.PrefetchKind.AUTO;
            break;
          case a.FetchStrategy.Full:
            e = i.PrefetchKind.FULL;
            break;
          case a.FetchStrategy.PPRRuntime:
            throw Object.defineProperty(
              new s.InvariantError(
                "FetchStrategy.PPRRuntime should never be used when `experimental.clientSegmentCache` is disabled",
              ),
              "__NEXT_ERROR_CODE",
              { value: "E772", enumerable: !1, configurable: !0 },
            );
          default:
            (r.fetchStrategy, (e = void 0));
        }
        return r.router.prefetch(r.prefetchHref, { kind: e });
      })().catch((e) => {}));
  }
  function S(e, t) {
    for (let r of h) {
      let n = r.prefetchTask;
      if (null !== n && !(0, a.isPrefetchTaskDirty)(n, e, t)) continue;
      null !== n && (0, a.cancelPrefetchTask)(n);
      let o = (0, a.createCacheKey)(r.prefetchHref, e);
      r.prefetchTask = (0, a.schedulePrefetchTask)(
        o,
        t,
        r.fetchStrategy,
        a.PrefetchPriority.Default,
        null,
      );
    }
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
